import { render, staticRenderFns } from "./WizardPage6.vue?vue&type=template&id=7261fa67"
import script from "./WizardPage6.vue?vue&type=script&lang=js"
export * from "./WizardPage6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports